import {
  ArrayField,
  ChipField,
  Datagrid,
  DateField,
  List,
  ListProps,
  SingleFieldList,
  TextField,
  TextInput,
  EditButton,
  useGetList,
  SelectInput,
  DeleteWithConfirmButton,
  WithRecord,
  number,
  ShowButton,
  BooleanField,
  BooleanInput,
} from "react-admin";
import { StandardPagination } from "../../common/StandardPagination";
export const ListJobOffers: React.FC<ListProps> = (props) => {
  const { data: statuses = [], isLoading: isLoadingStatuses } = useGetList("statuses");

  const filters = [
    <TextInput
      key="reference"
      label="Referencia"
      source="reference"
      validate={number()}
      alwaysOn
    />,

    <TextInput key="title" label="Título" source="title" alwaysOn />,

    <SelectInput
      key="status"
      label="Estado"
      source="status"
      choices={isLoadingStatuses ? [] : statuses}
      optionText="name"
      optionValue="name"
      alwaysOn
      disabled={isLoadingStatuses}
    />,

    <BooleanInput
      key="isFeatured"
      label="Oferta destacada"
      source="isFeatured"
      alwaysOn
      format={(value) => {
        if (typeof value === "string") {
          return value === "true";
        }
        return Boolean(value);
      }}
      parse={(value) => {
        if (typeof value === "string") {
          return value === "true";
        }
        return Boolean(value);
      }}
    />,
  ];

  return (
    <List
      {...props}
      perPage={10}
      filters={filters}
      sort={{ field: "reference", order: "DESC" }}
      pagination={<StandardPagination />}
    >
      <Datagrid optimized>
        <TextField source="reference" label="Referencia" />
        <TextField source="title" label="Título" />
        <BooleanField source="isFeatured" label="Destacada" />
        <DateField source="startDate" label="Fecha de inicio" />
        <DateField source="endDate" label="Fecha de fin" />
        <TextField source="status.name" label="Estado del llamado" />
        <ArrayField
          source="categories"
          label="Categorías"
          sortable={false}
          resource="categories"
        >
          <SingleFieldList linkType={false}>
            <ChipField source="name" />
          </SingleFieldList>
        </ArrayField>
        <WithRecord
          render={(record) => {
            const deleteTitle = `Eliminar llamado: ${record.reference}`;
            return (
              <>
                <EditButton label="Editar" />
                <ShowButton label="Ver" />
                <DeleteWithConfirmButton
                  mutationMode="pessimistic"
                  confirmTitle={deleteTitle}
                  confirmContent="¿Está seguro que desea eliminar este llamado? Esta acción no se puede deshacer."
                  record={record}
                  label="Eliminar"
                />
              </>
            );
          }}
        />
      </Datagrid>
    </List>
  );
};
